import { classNames } from "../../utils"
import { FlexColumn, type FlexColumnProps } from "../FlexColumn/FlexColumn"

export type VerticalAlignedProps = FlexColumnProps

export function VerticalAligned({ className, ...rest }: VerticalAlignedProps) {
  return (
    <FlexColumn className={classNames("justify-center", className)} {...rest} />
  )
}
